import { parseSetlistText } from '../components/SetlistEditor';
import { normalizeEmail, resolveMemberLabel, tourPartyMemberBlockId } from './tourPartyMemberUtils';

const EMAIL_RE = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi;

export function recipientLabel(person) {
  const name = String(person?.name || '').trim();
  const email = normalizeEmail(person?.email);
  return name || email || 'Recipient';
}

export function dedupeRecipients(list) {
  const byEmail = new Map();
  (list || []).forEach((person) => {
    const email = normalizeEmail(person?.email);
    if (!email) return;
    const existing = byEmail.get(email);
    if (!existing) {
      byEmail.set(email, {
        key: person.key || email,
        email,
        name: String(person.name || '').trim(),
        userId: String(person.userId || '').trim(),
        source: person.source || '',
      });
      return;
    }
    if (!existing.name && person.name) existing.name = String(person.name).trim();
    if (!existing.userId && person.userId) existing.userId = String(person.userId).trim();
  });
  return [...byEmail.values()];
}

export function tourPartyToRecipients(members = []) {
  return dedupeRecipients(
    (members || []).map((member) => ({
      key: `party-${tourPartyMemberBlockId(member)}`,
      email: normalizeEmail(member.email),
      name: resolveMemberLabel(member),
      userId: member.onPlatform ? String(member.id || '').trim() : '',
      source: 'tour_party',
    }))
  );
}

export function extractContactRecipientsFromRaw(raw) {
  const { songs } = parseSetlistText(raw);
  const rows = [];
  songs.forEach((song, index) => {
    const title = String(song.title || '').trim();
    const chunks = [title];
    (song.lines || []).forEach((line) => {
      (line.fields || []).forEach((f) => chunks.push(String(f ?? '')));
    });
    const text = chunks.join(' ');
    const matches = text.match(EMAIL_RE) || [];
    const displayName = title && !title.includes('@') ? title : '';
    matches.forEach((match) => {
      const email = normalizeEmail(match);
      if (!email) return;
      rows.push({
        key: `contact-${email}-${index}`,
        email,
        name: displayName,
        source: 'contacts',
      });
    });
  });
  return dedupeRecipients(rows);
}

export function mergeRecipientLists(...lists) {
  return dedupeRecipients(lists.flat());
}
